import { render, staticRenderFns } from "./user-open.vue?vue&type=template&id=da5951e8&scoped=true&"
import script from "./user-open.vue?vue&type=script&lang=js&"
export * from "./user-open.vue?vue&type=script&lang=js&"
import style0 from "./user-open.vue?vue&type=style&index=0&id=da5951e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5951e8",
  null
  
)

export default component.exports